<template>
  <div>
    <div class="flex space-x-3 items-baseline">
      <div class="min-w-0">
        <p class="text-sm font-medium text-gray-900 truncate">
          {{ user.fullName }}
        </p>
      </div>
      <time
        datetime="2021-01-27T16:35"
        class="flex-shrink-0 whitespace-nowrap text-xs text-gray-500"
        >{{ createdAt }}</time
      >
    </div>
    <div class="mt-1">
      <div class="text-sm text-gray-600 prose prose-sm" v-html="content" />
    </div>
  </div>
</template>

<script>
import { marked } from 'marked';
import moment from 'moment';

export default {
  props: {
    comment: {
      type: Object,
      required: true,
    },
  },
  computed: {
    user() {
      if (typeof this.comment.userId === 'undefined') {
        return null;
      }

      return this.$store.state.entities.users.byId?.[this.comment.userId] || null;
    },
    content() {
      return marked(this.comment.content);
    },
    createdAt() {
      return moment(this.comment.createdAt).fromNow();
    },
  },
};
</script>
